import axios, { baseURL } from '@axios'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    login(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/Login`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loginSms(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/LoginPhone`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    newPassword(ctx, userData) {
      const payload = {
        userName: userData.userName,
        password: userData.password,
        newPassword: userData.password,
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/ChangePassword`, payload, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    register(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/RegisterByEmail`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registerPhone(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/RegisterVerifyPhone`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    verifyPhone(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/VerfiyPhone`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    verifyPhoneFor(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Contact/LoginPhoneGetCaptcha`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registerShop(ctx, shopData) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Shop/AddOrUdpate`, shopData, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registerPayment(ctx, shopData) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/BankAccount/AddOrUdpate`, shopData, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getBanks() {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Bank/GetList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getShopTypes() {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Shop/GetShopTypeList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postProvince() {
     

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Province/GetProvinceList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
             
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postDistrict(ctx,province) {
     

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/District/GetDistrictList?provinceCode=${province}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
             
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postSubDistrict(ctx,payload) {
      

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SubDistrict/GetSubDistrictList?provinceCode=${payload.province}&districtCode=${payload.district}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
           
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getPrivacy() {
      const token = "bG9hZGJvYXJkVXNyOjU0MzQ1Mw=="
      return new Promise((resolve, reject) => {
        axios
          .get(`https://oms-api.promptsong.co/api/GetPrivatePolicy`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
